import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ErrorMessageComponent,
  SkeletonLoaderDirective
} from '@com-delta-omnichannel/aura';
import {
  CheckoutComponent,
  Membership,
  PurchaseOptionsComponent
} from '../../features';
import { SkyClubPage } from './models/sky-club-page.interfaces';

@Component({
  selector: 'idp-sky-club-page',
  standalone: true,
  imports: [
    PurchaseOptionsComponent,
    SkeletonLoaderDirective,
    CheckoutComponent,
    ErrorMessageComponent
  ],
  templateUrl: './sky-club-page.component.html',
  styleUrls: ['./sky-club-page.component.scss']
})
export class SkyClubPageComponent {
  @Input() content!: SkyClubPage;

  @Output() addToCart: EventEmitter<Membership> =
    new EventEmitter<Membership>();

  @Output() checkOut: EventEmitter<void> = new EventEmitter<void>();

  @Output() previousButton: EventEmitter<void> = new EventEmitter<void>();

  @Output() returnToSkyClub: EventEmitter<void> = new EventEmitter<void>();

  details = true;
}
